import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { parseToArray } from "../libs/Util";

const TopPanel = () => {
    const history = useNavigate();
    const [newsData, setNewsData] = useState({});
    const [releaseList, setReleaseList] = useState([]);
    const [bannerList, setBannerList] = useState([]);
    const trackRef = useRef(null);
    const animationFrameId = useRef(null);
    const isPaused = useRef(false);
    const speed = 0.5; // 움직이는 속도 (픽셀 단위)
    const [isOverflow, setIsOverflow] = useState(false);
    const [bannerIndex, setBannerIndex] = useState(0);

    useEffect(() => {
        getNewsData();
        getReleaseList();
        getBannerList();
        const track = trackRef.current;

        return () => {
            cleanupAnimationAndListeners(track);
        };
    }, []);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;
        const isOverflow = track.scrollWidth > track.clientWidth;
        setIsOverflow(isOverflow);
        if (isOverflow) {
            animationFrameId.current = requestAnimationFrame(animate);
            track.addEventListener("mouseenter", handleMouseEnter);
            track.addEventListener("mouseleave", handleMouseLeave);
        } else {
            cleanupAnimationAndListeners(track);
        }
    }, [releaseList]);

    // 배너가 바뀔 때마다 인덱스 초기화
    useEffect(() => {
        setBannerIndex(0);
    }, [bannerList.length]);

    // 캐러셀 이동 함수
    const handlePrevBanner = () => {
        if (bannerIndex > 0)
            setBannerIndex(prev => prev - 1);
    };
    const handleNextBanner = () => {
        if(bannerIndex + 1 < bannerList.length)
            setBannerIndex(prev => prev + 1);
    };

    const cleanupAnimationAndListeners = (track) => {
        cancelAnimationFrame(animationFrameId.current);
        track?.removeEventListener("mouseenter", handleMouseEnter);
        track?.removeEventListener("mouseleave", handleMouseLeave);
    };

    const animate = () => {
        if (!isPaused.current) {
            const track = trackRef.current;
            if (!track) return;
            const currentTransform = getComputedStyle(track).transform;
            const match = currentTransform.match(/matrix\((.*)\)/);
            const translateX = match ? parseFloat(match[1].split(", ")[4]) : 0;

            // 새로운 위치 계산
            const newPosition = translateX - speed;

            // 무한 스크롤: 트랙이 복제된 끝에 도달하면 원점으로 되돌림
            const resetPosition = Math.abs(newPosition) >= track.scrollWidth / 2 ? 0 : newPosition;
            track.style.transform = `translateX(${resetPosition}px)`;
        }

        animationFrameId.current = requestAnimationFrame(animate); // useRef로 저장
    };

    // hover 이벤트 처리
    const handleMouseEnter = () => isPaused.current = true;
    const handleMouseLeave = () => isPaused.current = false;

    const getReleaseList = async () => {
        const response = await fetch('/api/Document/GetReleaseContentList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                workingTag: "Home",
                pageNum: 1,
                rowNum: 3
            })
        });
        if (response.status === 200) {
            const result = await response.json();
            if (result.table && result.table.length > 0) {
                setReleaseList(result.table);
            }
        }
    }

    const getBannerList = async () => {
        const response = await fetch('datas/oper/banners.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        });
        const result = await response.json();
        if (result && result.length > 0) {
            const visibleBanners = result.filter(banner => banner.isVisible);
            setBannerList(prevList => [...visibleBanners, ...prevList]);
        }
    };

    const getNewsData = async () => {
        const response = await fetch('datas/oper/news.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        });
        const result = await response.json();
        if (result && result.children) {
            setNewsData(result);
        }
    }
    const getNewsId = (newsItem) => {
        if (!newsData || !newsData.children) return '';
        return newsData.children.find((newsInfo) => { if (newsInfo.groupno == JSON.parse(newsItem.content).groupNo) return newsInfo; }).id;
    }
    const movePage = (item) => {
        history(`/${item.path}`, { state: JSON.parse(item.content) });
    }

    const openBanner = (item) => {
        if (item.content && item.content !== "") {
            history(`/${item.url}`,{state: JSON.parse(item.content)});
        } else
            window.open(item.url, '_blank')
    }

    const slideStyle = {
        maxWidth: "100%",
        overflow: "hidden"
    }

    const containerStyle = {
        width: "502px",
        display: "flex", 
        overflow: "hidden"
    }

    const animationStyle = {
        minWidth: "100%",
        transform: `translateX(-${bannerIndex * 100}%)`,
        transition: "transform 0.5s ease-in-out"
    }

    return (
        <section className="top">
            <div className="hero">
                <div className="hero-title">
                    <p className="hero-p">친절하고 자세한 가이드, 효율적인 개발의 시작</p>
                    <h1 className="hero-h1"><span>KDC</span>를 통해<br />개발에 날개를 달아보세요.</h1>
                </div>
                <div className="notice-wrap">
                    <div className="notice-wrap-slide">
                        {bannerList.length > 1 && (
                            <>
                                {bannerIndex > 0 &&
                                    <Link style={{ left: "-50px" }} onClick={handlePrevBanner}>
                                        <i className="icoKdcMask24 slide-left"></i>
                                    </Link>
                                }
                                {bannerIndex < bannerList.length - 1 &&
                                    <Link style={{ right: "-50px" }} onClick={handleNextBanner}>
                                        <i className="icoKdcMask24 slide-right"></i>
                                    </Link>
                                }
                            </>
                        )}
                        <div className="" style={containerStyle}>
                            {bannerList.map((item, index) => 
                                <div key={index} className="notice-banner" style={animationStyle}>
                                    <div className="notice-banner-inner">
                                        <h3 className="notice-title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
                                        <p className="notice-txt" dangerouslySetInnerHTML={{ __html: item.text }}></p>
                                    </div>
                                    {item.url && item.button &&
                                        <button className="btn-go" onClick={() => openBanner(item)}>{item.button}
                                            <i className="icoKdc16 seemore"></i>
                                        </button>
                                    }
                                </div>
                            )}
                        </div>
                        <div className="notice-pagination">
                            <ul className="pagination-list">
                                {bannerList.map((item, index) =>
                                    <li className={`pagination-item ${index === bannerIndex ? "active" : ""}`}></li>
                                )}
                            </ul>
                        </div>
                    </div >
                </div >
            </div >
    <div className="top-slide" style={slideStyle}>
        <ul className="slide-box-wrap" ref={trackRef}>
            {releaseList && releaseList.concat(isOverflow ? releaseList : []).map((item, index) => {
                let category = '';
                if (item.category?.includes("/")) {
                    category = item.category.split("/").pop();
                }
                return (
                    <li key={index} className="slide-box" onClick={() => movePage(item)}>
                        <div className="slide-box-kdcnews-top">
                            <div className="slide-box-badge">
                                <i className={`icoKdc24 ${item.type === "kdcnews" ? "kdcmegaphone" : item.type}`}></i>
                                <p className={`slide-box-badge-${item.type}`}>{item.message}</p>
                            </div>
                            <span className="date">{item.updateDate}</span>
                        </div>
                        {item.type === "kdcnews" ?
                            <div className="slide-box-kdcnews-bottom">
                                <div className={`slide-box-kdc${getNewsId(item)}`}></div>
                                <div className="kdcnews-title">
                                    <p className="slide-box-kdcnews-cate">{item.category} 공통</p>
                                    <h3 className="box-title">{item.title}</h3>
                                </div>
                            </div>
                            :
                            <div className="slide-box-manual-bottom">
                                <h4 className="box-cate">{category}</h4>
                                <h3 className="box-title">{item.title}</h3>
                                <div className="box-tags">
                                    {parseToArray(item.tag).map((tag, tagIndex) => (
                                        <span key={tagIndex}>{tag}</span>
                                    ))}
                                </div>
                                {item.fullPath && (
                                    <div className="path" key={index}>
                                        {JSON.parse(item.fullPath).map((path, index, arr) => (
                                            <React.Fragment key={index}>
                                                <span className="path-li">{path}</span>
                                                {index < arr.length - 1 && <i className="icoKdc12 next"></i>}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                            </div>
                        }
                    </li>
                )
            })}
        </ul>
    </div>
        </section >
    );
}

export default TopPanel;